import React, { memo } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  boxRoot: {},
  typographyRoot: {
    margin: 0,
  },
  typographyBody1: {
    ...theme.typography.body1,
  },
  noWrap: {
    whiteSpace: "nowrap",
  },
}));

export const View = memo(({ children, className, ...props }) => {
  const styles = useStyles();
  return (
    <div className={clsx(styles.boxRoot, className)} {...props}>
      {children}
    </div>
  );
});

export const Text = memo(({ children, className, noWrap, ...props }) => {
  const styles = useStyles();
  return (
    <p
      className={clsx(
        styles.typographyRoot,
        styles.typographyBody1,
        className,
        noWrap && styles.noWrap
      )}
      {...props}
    >
      {children}
    </p>
  );
});
